angular.module('rjmNg.api').factory 'DashboardDividers', [
  "$cacheFactory"
  "$resource"
  "dashboardConstants"
  "DashboardItem"
  "dashboardService"
  "serviceUrl"
  (
    $cacheFactory
    $resource
    dashboardConstants
    DashboardItem
    dashboardService
    serviceUrl
  ) ->
    defaultParams =
      withCredentials: true
      headers:
        Accept: 'application/json'
        'Content-Type': 'application/json'

    actionUrls =
      base: serviceUrl("/dashboards/:dashboardId/dividers")
      edit: serviceUrl("/dashboards/:dashboardId/dividers/:dividerId")

    actions =
      get: angular.extend {}, defaultParams,
        method: 'GET'
        isArray: true
        url: actionUrls.base
        cache: $cacheFactory.get('DashboardDividers') or $cacheFactory('DashboardDividers')
      create: angular.extend {}, defaultParams,
        method: 'POST'
        url: actionUrls.base
      save: angular.extend {}, defaultParams,
        method: 'PUT'
        url: actionUrls.edit
      delete: angular.extend {}, defaultParams,
        method: 'DELETE'
        url: actionUrls.edit

    resource = $resource("", {}, actions)

    clearCache = () ->
      $cacheFactory.get('DashboardDividers')?.removeAll()

    getByDashboardId = (dashboardId) ->
      resource.get({dashboardId}).$promise

    create = (dashboardId, type, value = "") ->
      clearCache()
      if type is dashboardConstants.DIVIDER_TYPES.BREAK
        value = ""
      else if type is dashboardConstants.DIVIDER_TYPES.HEADING and value is ""
        value = "HEADER"

      resource.create(
        {dashboardId}
        {type, value}
      ).$promise

    save = (dashboardId, dividerId, type, value) ->
      if type is dashboardConstants.DIVIDER_TYPES.HEADING and value is ""
        throw "Value cannot be an empty string for divider heading."
      else if type is dashboardConstants.DIVIDER_TYPES.BREAK
        throw "There is nothing to update for divider break."
      else
        clearCache()
        resource.save(
          {dashboardId, dividerId}
          {type, value}
        ).$promise

    del = (dashboardId, dividerId) ->
      clearCache()
      resource.delete({dashboardId, dividerId}).$promise

    updateDividerHeadingValue = (divider, dashboardId) ->
      if divider.value isnt divider.oldValue and
        divider.type isnt dashboardConstants.DIVIDER_TYPES.BREAK
          if divider.type is dashboardConstants.DIVIDER_TYPES.HEADING and divider.value is ""
            divider.value = divider.oldValue
          else
            save(
              dashboardId
              divider.id
              divider.type
              divider.value
            ).then () ->
              divider.oldValue = divider.value
            .catch () ->
              divider.value = divider.oldValue
      else
        divider.value = divider.oldValue

    addDividerToDashboard = (dashboardId, clientId, type, row = 0, sizeY = 0) ->
      create(dashboardId, type)
      .then (divider) ->
        DashboardItem.save(
          clientId: clientId
        ,
          dashId: dashboardId
          dividerId: divider.id
          row: row + 1 + sizeY
          column: 1
        , (dashboardItem) ->
            dashboardService.dashboardItemAdded(dashboardItem)
            return
        )

      return

    {
      getByDashboardId: getByDashboardId
      create: create
      save: save
      delete: del
      addDividerToDashboard: addDividerToDashboard
      updateDividerHeadingValue: updateDividerHeadingValue
    }
  ]
